import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import { GreenIconSVG } from '../SVG/GreenIconSVG';
import CloseIcon from '../SVG/CloseIcon';
import { postRequest } from '../../helpers/apiHandler';
import CreatableSelect from 'react-select/creatable';
import { reloadContactList, reloadContactOverview } from '../../store/actions/reduxAction';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import InfoIcon from '../../assets/icon-info.svg';

const ContactAssignTags = (props) => {
  const { modalTagsShow, setTagsShow, allTags, selectedRows, access_token, reloadContactList, reloadContactOverview } = props;

  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (modalTagsShow === true) {
      setTagOptions(allTags);
    }
  }, [modalTagsShow]);

  const handleModalClose = () => {
    setTagsShow(false);
  };
  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  const handleSave = () => {

    const tags = selectedTags.map(tag => tag.value);
    const contact_ids = selectedRows.map(row => row.id)

    const data = {
      contact_ids: contact_ids,
      tags: tags,
    };

    postRequest(`/v2/contacts-assign-tags`, data, access_token.token, (res) => {
      if (res.success) {
        // Handle success if needed
        handleModalClose(true)
        reloadContactList();
        reloadContactOverview();
        setAlertState({
          message: 'Contact(s) tags saved successfully',
          show: true,
          variant: 'success',
        });
      }
    });
  };

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal
        show={modalTagsShow}
        animation={true}
        onHide={handleModalClose}
        className="modal-form-contact"
        centered
      >
        <Modal.Body>
          <CloseIcon handleModalClose={handleModalClose} />
          <GreenIconSVG />
          <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
            Assign Tag(s)
          </Modal.Title>
          <p>Please enter one or more tags to be assigned to the selected contacts(s)</p>
          <Form>
            <Form.Group>
              <Form.Label>Add Tag(s)</Form.Label>
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="tooltip-name">
                    Assign tags: Select from dropdown or type and press Enter to tag contacts.
                  </Tooltip>
                }
              >
                <span className="ml-2"><img src={InfoIcon} style={{ width: '14px' }}></img></span>
              </OverlayTrigger>
              <CreatableSelect
                options={tagOptions.map(tag => ({ value: tag, label: tag }))}
                isMulti
                value={selectedTags}
                onChange={setSelectedTags}
              />
            </Form.Group>
            <Form.Group>
              <Button variant="primary" style={{ minWidth: 160 }} onClick={handleSave}>
                Save
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = dispatch => ({
  reloadContactList: () => dispatch(reloadContactList()),
  reloadContactOverview: () => dispatch(reloadContactOverview())
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactAssignTags);
